export default ".dx-scrollview-content{display:flex;flex-grow:1}";